import PropTypes from 'prop-types';
import React from 'react';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import { QUESTION_FILTER_TYPE } from '../../../../constants/common';

const getFilterOptions = (filter) => {
  const options = filter.options || [];
  const optionList = options[0]?.options ? options[0].options : options;
  return optionList.filter(
    (option) => Number(option.code) >= 0 || Number.isNaN(Number(option.code))
  );
};

const OtherFilters = ({ filters }) => {
  // Still loading the filters from the backend.
  if (!filters) {
    return (
      <Row>
        <Col className="d-flex justify-content-center mt-5">
          <Spinner animation="border" />
        </Col>
      </Row>
    );
  }

  const attributeFilters = filters.filter(
    (filter) => filter.type === QUESTION_FILTER_TYPE.ATTRIBUTE
  );

  return (
    <Card className="survey-info-card bg-gray">
      <Card.Header className="survey-info-card-header">Other Filters</Card.Header>
      {attributeFilters.length === 0 && (
        <div className="p-4 text-center">
          <b>This survey does not contain any other filters.</b>
        </div>
      )}
      {attributeFilters.map((filter) => (
        <Card key={filter.code} className="survey-info-card m-3">
          <Card.Body>
            <h4 className="mb-2">{filter.label || filter.description}</h4>
            <ul className="mb-0">
              {getFilterOptions(filter).map((option) => (
                <li key={option.code}>{option.description}</li>
              ))}
            </ul>
          </Card.Body>
        </Card>
      ))}
    </Card>
  );
};

OtherFilters.propTypes = {
  // eslint-disable-next-line react/require-default-props
  filters: PropTypes.arrayOf(PropTypes.object),
};

export default OtherFilters;
